export enum MetaDataKey {
  eventId,
  stageId,
  venueId,
  supplierId,
  venuesId,
  artistId,
  bookingId,
  selectedDate,
  selectedFromDateTime,
  selectedToDateTime,
  fileRelation,
  stationType,
  contactAssociationType,
  contactId,
  fileParentType,
  fileParentId,
  invoiceId,
  deleteWithConfirmation,
}
export interface MetaData {
  key: MetaDataKey
  value: any | null | undefined
}
